export default "__VITE_ASSET__Baj1LT23__"